export default __webpack_public_path__ + "6b6975b84dbafb83f85033d1dad05ec9.svg";